import { Options } from 'highcharts';
import { WidgetType } from 'api/dashboard/widget';
import { unreachable } from 'utils/unreachable';
import { getCustomChartOptions } from './get-custom-chart-options';
import { getInferredProgressByProjectOwnerOptions } from './inferred-progress-by-project-owner';
import { getInferredProgressByTemplateOptions } from './inferred-progress-by-template';
import { getProjectByInferredProgressOptions } from './project-by-inferred-progress';
import { getProjectByStatusOptions } from './project-by-status';
import { getStatusByPhasesOptions } from './status-by-phases';
import { getTasksByStatusOptions } from './tasks-by-status';

export const getOptionsForChart = (
  type: WidgetType,
  initialOptions?: Options,
): Options => {
  switch (type) {
    case WidgetType.InferredProgressByProjectOwner:
      return getInferredProgressByProjectOwnerOptions(initialOptions);
    case WidgetType.InferredProgressByTemplate:
      return getInferredProgressByTemplateOptions(initialOptions);
    case WidgetType.ProjectByInferredProgress:
      return getProjectByInferredProgressOptions(initialOptions);
    case WidgetType.ProjectByStatus:
      return getProjectByStatusOptions(initialOptions);
    case WidgetType.StatusByPhase:
      return getStatusByPhasesOptions(initialOptions);
    case WidgetType.TaskByStatus:
      return getTasksByStatusOptions(initialOptions);
    case WidgetType.CustomChart:
      return getCustomChartOptions(initialOptions);
    case WidgetType.CustomCard:
      return unreachable(type as never);
    case WidgetType.ProjectCount:
      return unreachable(type as never);
    case WidgetType.ARR:
      return unreachable(type as never);
    default:
      return unreachable(type);
  }
};

export {
  WIDGET_CONTENT_HEIGHT,
  WIDGET_CONTENT_HEIGHT_WITH_SCROLLBAR,
} from './utils';
